// External redirects for specific country storefronts
// This file handles redirections to external Shopify storefronts

/**
 * Configuration for external Shopify storefront redirects
 */

// Define a type for the config
interface StorefrontConfig {
  target: string
  hreflang: string
}

// Define a type with specific country codes as keys
interface ExternalStorefrontMap {
  [key: string]: StorefrontConfig
}

// Type your constant properly
export const EXTERNAL_SHOPIFY_REDIRECTS: ExternalStorefrontMap = {
  AU: { target: 'https://www.happysocks.com.au', hreflang: 'en-au' },
  NZ: { target: 'https://www.happysocks.com.au/en-nz', hreflang: 'en-nz' },
  // other countries...
}

/**
 * Check if a country should be redirected to an external Shopify storefront
 *
 * @param countryCode The country code to check
 * @returns Boolean indicating if this country redirects to a Shopify storefront
 */
export function isExternalShopifyStorefront(countryCode: string): boolean {
  return Object.keys(EXTERNAL_SHOPIFY_REDIRECTS).includes(countryCode.toUpperCase())
}

/**
 * Get the external Shopify storefront URL for a given country code
 *
 * @param countryCode The country code to get the redirect for
 * @returns The external storefront URL or null if not found
 */
export function getExternalStorefrontUrl(countryCode: string): string | null {
  const upperCode = countryCode.toUpperCase()
  return upperCode in EXTERNAL_SHOPIFY_REDIRECTS
    ? EXTERNAL_SHOPIFY_REDIRECTS[upperCode].target
    : null
}
